"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverrideReason = exports.BoxReceiveType = void 0;
var BoxReceiveType;
(function (BoxReceiveType) {
    BoxReceiveType["DECANT"] = "DECANT";
    BoxReceiveType["NON_DECANT"] = "NON_DECANT";
})(BoxReceiveType = exports.BoxReceiveType || (exports.BoxReceiveType = {}));
var OverrideReason;
(function (OverrideReason) {
    OverrideReason["OTHER"] = "OTHER";
    OverrideReason["BOX_TOO_LARGE"] = "BOX_TOO_LARGE";
    OverrideReason["DIRECTED_BY_LEADERSHIP"] = "DIRECTED_BY_LEADERSHIP";
})(OverrideReason = exports.OverrideReason || (exports.OverrideReason = {}));
//# sourceMappingURL=BoxSortation.js.map